<template>
  <div>
    <div>
        <quickQuery @handleQuery="handleQuery" @quickQuery="quickQuery" @download="download" :initSearchTime="searchTime"  :isMounted="false" style="text-align: right" />
    </div>
    <div class="page_container_a">
      <el-table 
        :data="list" 
        :size="size" 
        border
        v-loading="loading"
      >
        <el-table-column prop="ranking" align="center" min-width="85" :label="$t('driver.ranking')" fixed="left"></el-table-column><!--名次 -->
        <el-table-column prop="carNo" align="center" min-width="120" :label="$t('vehicle.carNo')" fixed="left"></el-table-column><!-- 车牌号-->
        <el-table-column prop="runTime" align="center" min-width="80" :label="$t('driver.runTime')" fixed="left">
          <template slot-scope="scope">
            {{secondsToHMS(scope.row.runTime)}}
          </template>
        </el-table-column><!-- 运行时间（小时）+'('+$t('time.hour')+')'-->
        <el-table-column prop="runMileage" align="center" min-width="120" :label="$t('driver.runMileage')" fixed="left"></el-table-column><!-- 运行里程  (公里)-->
        <el-table-column prop="score" align="center" min-width="65" :label="$t('driver.score')" fixed="left"></el-table-column><!-- 总分-->
        <el-table-column align="center" min-width="110" :label="$t('driver.star')" fixed="left"> <!-- 星级-->
          <template slot-scope="scope">
            <div >
              <img v-for="(item,index) in imgSrc(scope.row.score)" :key="index" :src="item" style="width:12px;height:12px" />
              <!-- index 是从0开始 -->
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="overspeed_number" align="center" width="75" :label="$t('driver.overspeed_number')"></el-table-column><!-- 超速次数 /千公里-->
        <el-table-column prop="overspeed_duration" align="center" width="75" :label="$t('driver.overspeed_duration')"></el-table-column><!-- 超速时长 /千公里-->
        <el-table-column prop="overturn_number" align="center" width="75" :label="$t('driver.overturn_number')"></el-table-column><!-- 超转次数 /千公里-->
        <el-table-column prop="overturn_duration" align="center" width="75" :label="$t('driver.overturn_duration')"></el-table-column><!--超转时长 /千公里 -->
        <el-table-column prop="idleSpeed_number" align="center" width="75" :label="$t('driver.idleSpeed_number')"></el-table-column><!-- 怠速次数 /千公里-->
        <el-table-column prop="idleSpeed_duration" align="center" width="75" :label="$t('driver.idleSpeed_duration')"></el-table-column><!-- 怠速时长 /千公里-->
        <el-table-column prop="rapidAcceleration_number" align="center" width="85" :label="$t('driver.rapidAcceleration_number')"></el-table-column><!--急加速次数 /千公里 -->
        <el-table-column prop="rapidAcceleration_duration" align="center" width="85" :label="$t('driver.rapidAcceleration_duration')"></el-table-column><!--急加速时长 /千公里 -->
        <el-table-column prop="rapidDeceleration_number" align="center" width="85" :label="$t('driver.rapidDeceleration_number')"></el-table-column><!-- 急减速次数 /千公里-->
        <el-table-column prop="rapidDeceleration_duration" align="center" width="85" :label="$t('driver.rapidDeceleration_duration')"></el-table-column><!-- 急减速时长 /千公里-->
        <el-table-column prop="coasting_number" align="center" width="95" :label="$t('driver.coasting_number')"></el-table-column><!--空挡滑行次数 /千公里 -->
        <el-table-column prop="coasting_duration" align="center" width="95" :label="$t('driver.coasting_duration')"></el-table-column><!--空挡滑行时长 /千公里 -->
        <el-table-column prop="fatigueDriving_number" align="center" width="95" :label="$t('driver.fatigueDriving_number')"></el-table-column><!--疲劳驾驶次数 /千公里 -->
        <el-table-column prop="fatigueDriving_duration" align="center" width="95" :label="$t('driver.fatigueDriving_duration')"></el-table-column><!-- 疲劳驾驶时长 /千公里-->
        <!-- <el-table-column align="center" label=""></el-table-column> -->
      </el-table>
    </div>
    <!-- 分页 -->
    <div>
      <kl-pagination  :total="total" @current-change="pageChange" :pageSize="pageSize" :currentPage="currentPage"></kl-pagination>
    </div>
  </div>
</template>
<script>
import quickQuery from '../../statistics/components/generalOrQuickQuery.vue'
import { mapState } from 'vuex'
export default {
  components:{
    quickQuery,
  },
  data(){
    return{
      dataList:[],
      vehicles:"",
      form:undefined,
      pageSize:10,
      currentPage:1,
      total:0,
      loading:false,
      searchTime:[new Date(new Date().getTime() - 1 * 24 * 60 * 60 * 1000),new Date(new Date().getTime() - 1 * 24 * 60 * 60 * 1000)]
    }
  },
  props:{
    initDataList:{
    },
    initTotal:{
      type:Number,
      default:0
    },
    size:{
      type:String,
    },
    selectedVehicles:{
    },
    _loading:{
      type:Boolean,
      default:false,
    }
  },
  computed:{
    operator() {
        return this.$store.getters.operator
    },
    imgSrc() {
      return (score) => {
        if(score >= 0){
          let Star = [];
          var realStar = 0;
          var halfStar = 0;
          var voidStar = 0;
          realStar = parseInt((score)/20);
          halfStar = Number.isInteger((score)/20) ? 0 : 1;
          voidStar = 5 - realStar - halfStar;
          // console.log(realStar,halfStar,voidStar);
          if(realStar == 0) {
            for(var i = 0; i < 5 ; i++){
              Star.push(require("@/assets/svgs/icon_driver3.svg"));
            }
            return Star;
          }
          if(realStar > 0){
            for(var i = 0; i < realStar; i++){
              Star.push(require("@/assets/svgs/icon_driver1.svg"));
            }
          }
          halfStar == 1 ? Star.push(require("@/assets/svgs/icon_driver2.svg")) : Star;
          if(voidStar > 0){
            for(var i = 0; i < voidStar; i++){
              Star.push(require("@/assets/svgs/icon_driver3.svg"));
            }
          }
          // console.log(Star);
          return Star;
        }
      };
    },
    list(){
      if(this.dataList != null && this.dataList.length > 0){
        return this.dataList.slice((this.currentPage - 1) * this.pageSize,this.currentPage * this.pageSize)
      }
      return [];
    },
  },
  watch:{
    _loading(newval){
      this.loading = newval;
    },
    initDataList(newVal){
      // console.log(newVal)
      
      this.dataList = newVal;
      deep: true
    },
    initTotal(newVal){
      this.total = newVal;
    }
  },
  methods:{
    secondsToHMS(seconds) {
      // 计算小时
      const hours = Math.floor(seconds / 3600);
      // 计算分钟
      const minutes = Math.floor((seconds % 3600) / 60);
      // 计算秒钟
      const secs = seconds % 60;

      // 格式化小时、分钟和秒钟
      const formattedHours = hours.toString().padStart(2, '0');
      const formattedMinutes = minutes.toString().padStart(2, '0');
      const formattedSecs = secs.toString().padStart(2, '0');

      return `${formattedHours}:${formattedMinutes}:${formattedSecs}`;
    },

    fixed2(val){
      if(val == 0 || val == null || val == undefined || val == ""){
        return 0;
      }
      if(Number.isInteger(val)) return val;
      return val.toFixed(2)
    },
    // 分页
    pageChange(page) {
      this.currentPage = page;
    },
    getSelectedVehicles(){
      this.vehicles = "";
      for(let k = 0; k < this.selectedVehicles.length; k++){
        if(this.selectedVehicles[k].treeLevel == 5){
          this.vehicles = this.vehicles + this.selectedVehicles[k].nodeValue + ",";
        }
      }
      return this.vehicles.substring(0,this.vehicles.length-1);
    },
    handleQuery(val){
      this.form = val;
      this.currentPage = 1;
      this.vehicles = this.getSelectedVehicles();
      if(this.form.beginDate == "" || this.form.beginDate == null || this.form.beginDate == undefined){
        this.$message({
          message: this.$t("runState.select_search_date"),//'请选择查询时间',
          type: 'warning'
        });
        return ;
      }
      this.getList();
    },
    quickQuery(val){
      this.form = val;
      this.currentPage = 1;
      this.vehicles = this.getSelectedVehicles();
      this.getList();
    },
    download(){
      if(this.dataList.length == 0){
        this.$message.info(this.$t("statistics.PleQuery"));
        return;
      }
      //换一种导出
      var fileName = this.$t("driver.vehiScoreDetail")+this.$t("public.download");
      import('../../statistics/components/Export2Excel').then(excel => {
        const tHeader = [this.$t("driver.ranking"),
          this.$t("vehicle.carNo"),
          this.$t("driver.runTime"),
          this.$t("driver.runMileage"),
          this.$t("driver.score"),
          this.$t("driver.overspeed_number"),
          this.$t("driver.overspeed_duration"),
          this.$t("driver.overturn_number"),
          this.$t("driver.overturn_duration"),
          this.$t("driver.idleSpeed_number"),
          this.$t("driver.idleSpeed_duration"),
          this.$t("driver.rapidAcceleration_number"),
          this.$t("driver.rapidAcceleration_duration"),
          this.$t("driver.rapidDeceleration_number"),
          this.$t("driver.rapidDeceleration_duration"),
          this.$t("driver.coasting_number"),
          this.$t("driver.coasting_duration"),
          this.$t("driver.fatigueDriving_number"),
          this.$t("driver.fatigueDriving_duration")];
        const filterVal = ["ranking", "carNo", "runTime", "runMileage", "score", "overspeed_number",
          "overspeed_duration","overturn_number","overturn_duration","idleSpeed_number","idleSpeed_duration","rapidAcceleration_number",
          "rapidAcceleration_duration","rapidDeceleration_number","rapidDeceleration_duration","coasting_number","coasting_duration","fatigueDriving_number",
          "fatigueDriving_duration"];
        const list = JSON.parse(JSON.stringify(this.dataList));
        const data = this.formatJson(filterVal, list)
        excel.export_json_to_excel({
          header: tHeader,
          data,
          filename: fileName,
          autoWidth: true,
          bookType: this.bookType
        })
      })

      // //导出
      // var fileName = this.$t("driver.vehiScoreDetail")+this.$t("public.download");
      // var data = this.dataList;
      // var keys = ["ranking", "carNo", "runTime", "runMileage", "score", "overspeed_number",
      //   "overspeed_duration","overturn_number","overturn_duration","idleSpeed_number","idleSpeed_duration","rapidAcceleration_number",
      //   "rapidAcceleration_duration","rapidDeceleration_number","rapidDeceleration_duration","coasting_number","coasting_duration","fatigueDriving_number",
      //   "fatigueDriving_duration"];
      // let str = this.$t("driver.ranking")+","
      //   +this.$t("vehicle.carNo")+","
      //   +this.$t("driver.runTime")+","
      //   +this.$t("driver.runMileage")+","
      //   +this.$t("driver.score")+","
      //   +this.$t("driver.overspeed_number")+","
      //   +this.$t("driver.overspeed_duration")+","
      //   +this.$t("driver.overturn_number")+","
      //   +this.$t("driver.overturn_duration")+","
      //   +this.$t("driver.idleSpeed_number")+","
      //   +this.$t("driver.idleSpeed_duration")+","
      //   +this.$t("driver.rapidAcceleration_number")+","
      //   +this.$t("driver.rapidAcceleration_duration")+","
      //   +this.$t("driver.rapidDeceleration_number")+","
      //   +this.$t("driver.rapidDeceleration_duration")+","
      //   +this.$t("driver.coasting_number")+","
      //   +this.$t("driver.coasting_duration")+","
      //   +this.$t("driver.fatigueDriving_number")+","
      //   +this.$t("driver.fatigueDriving_duration")+"\n";
      // // `序号,分组,车牌号,开始里程,结束里程,本阶段行驶里程,总行驶里程,\n`;
      // //增加\t为了不让表格显示科学计数法或者其他格式
      // for (let i = 0; i < data.length; i++) {
      //   for (let j = 0; j < keys.length; j++) {
      //     str += `${data[i][keys[j]] + '\t'},`;
      //   }
      //   str += '\n';
      // }
      // //encodeURIComponent解决中文乱码
      // let uri = 'data:text/csv;charset=utf-8,\ufeff' + encodeURIComponent(str);
      // //通过创建a标签实现
      // let link = document.createElement("a");
      // link.href = uri;
      // //对下载的文件命名
      // link.download = `${fileName || '数据'}.xlsx`;
      // document.body.appendChild(link);
      // link.click();
      // document.body.removeChild(link);
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => {
        if(j == "runTime"){
          return this.secondsToHMS(v[j])
        }
          return v[j]
        
      }))
    },
    getList(){
      this.loading = true;
      this.$api.scoreInfo({
        vehicles: this.vehicles,
        beginDate: this.form.beginDate,
        endDate: this.form.endDate,
        OperatorID: this.operator.OperatorId + "",//1668
        // OperatorID: 1668 + "",
      })
      .then((res)=>{
        if(res && res.code == 200){
          this.dataList = res.data;
          this.total = res.count;
          this.loading = false;
        }
      })
      .catch((e)=>{
        this.loading = false;
      })
    },
  },
  mounted(){

  }
}
</script>
<style lang="scss" scoped>
.page_container_a {
    margin-top: 10px;

    ::v-deep .el-table tr {
        background: rgb(244, 248, 255);
    }

    ::v-deep .el-table {
        background: rgb(244, 248, 255);
    }

    ::v-deep .el-table td {
        background: rgb(244, 248, 255);
    }
} 
</style>